// extracted by mini-css-extract-plugin
module.exports = {"table":"SystemModule_table__CIXhL","left":"SystemModule_left__1K7RI"};